var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignUpSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 122,
    viewBox: "0 0 136 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.4998 0.499985C67.1781 0.499985 53.443 6.18926 43.316 16.3162C33.189 26.4432 27.4998 40.1783 27.4998 54.5C27.4998 68.8217 33.189 82.5568 43.316 92.6838C53.443 102.811 67.1781 108.5 81.4998 108.5C95.8215 108.5 109.557 102.811 119.684 92.6838C129.811 82.5568 135.5 68.8217 135.5 54.5H122C122 76.91 103.91 95 81.4998 95C70.7585 95 60.4572 90.733 52.8619 83.1378C45.2667 75.5426 40.9998 65.2412 40.9998 54.5C40.9998 43.7587 45.2667 33.4574 52.8619 25.8622C60.4572 18.2669 70.7585 14 81.4998 14C84.4023 14 87.3048 14.3375 90.0723 14.945L100.94 4.14498C94.7298 1.71498 88.2498 0.499985 81.4998 0.499985ZM125.982 11.165L81.4998 55.6475L65.4348 39.5825L55.9173 49.1675L81.4998 74.75L135.5 20.75M20.2773 26.285C7.78976 36.545 0.499756 51.8675 0.499756 68C0.499756 82.3217 6.18903 96.0568 16.316 106.184C26.443 116.311 40.1781 122 54.4998 122C58.8198 122 63.0723 121.46 67.1898 120.447C55.3098 117.815 44.3748 111.875 35.3973 103.707C22.2348 96.6875 13.9998 82.9175 13.9998 68C13.9998 65.975 14.2023 64.0175 14.4723 61.9925C14.2023 59.495 13.9998 56.9975 13.9998 54.5C13.9998 44.78 16.1598 35.1275 20.2773 26.285Z",
    fill: "#00C566"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUpSuccess);
export default __webpack_public_path__ + "static/media/sign-up-success.11d9c1e4d4d9711863b96379dcebd44f.svg";
export { ForwardRef as ReactComponent };